import { useState, useEffect, useCallback } from 'react';

const useTimer = () => {
    const [currentMinutes, setMinutes] = useState(0);
    const [currentSeconds, setSeconds] = useState(1);
    const [duration, setDuration] = useState(0);
    const [isRunning, setIsRunning] = useState(false);

    const startHandler = (duration: number) => {
        setDuration(duration);

        const minutes = duration / 60;
        const seconds = duration % 60;

        setMinutes(minutes);
        setSeconds(seconds);

        setIsRunning(true);
    };
    const stopHandler = () => {
        // stop timer
        setIsRunning(false);
    };
    const resetHandler = (ticks: number, duration = 10) => {
        const date = new Date(ticks);
        setMinutes(date.getMinutes());
        setSeconds(date.getSeconds());
        setIsRunning(false);
        setDuration(duration);
    };

    const resumeHandler = () => {
        const newDuration = currentMinutes * 60 + currentSeconds;
        setDuration(newDuration);

        setIsRunning(true);
    };

    useEffect(() => {
        if (isRunning === true) {
            let timer = duration;
            let minutes, seconds;
            const interval = setInterval(function () {
                if (--timer <= 0) {
                    resetHandler(0);
                } else {
                    minutes = timer / 60;
                    seconds = timer % 60;

                    setMinutes(minutes);
                    setSeconds(seconds);
                }
            }, 1000);
            return () => clearInterval(interval);
        }
    }, [duration, isRunning]);

    return {
        start: useCallback(startHandler, []),
        stop: useCallback(stopHandler, []),
        reset: useCallback(resetHandler, []),
        resume: useCallback(resumeHandler, [currentMinutes, currentSeconds]),
        seconds: currentSeconds,
        minutes: currentMinutes
    };
};

export { useTimer };
